import React from "react";
import aleHeadshot from "./images/logos/ale_headshot.png";
import ownerProfile from "./images/logos/OwnerProfile1.JPG";

const photographerImages = {
  portrait: {
    src: aleHeadshot,
    alt: "Portrait of Alejandro Armas, Los Angeles photographer",
  },
  working: {
    src: ownerProfile,
    alt: "Alejandro Armas photographing in Los Angeles",
  },
};

function About() {
  return (
    <main className="relative mx-auto min-h-screen max-w-7xl overflow-hidden px-6 pb-24 pt-32 sm:px-10 md:px-16 md:pt-40">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 top-28 h-72 w-72 rounded-full border border-stone-300/70 animate-[drift_12s_ease-in-out_infinite]"
      />

      <section className="relative max-w-4xl">
        <div className="mb-20">
          <p className="mb-6 animate-[fadeUp_700ms_ease-out_both] text-xs font-medium uppercase tracking-[0.3em] text-stone-500">
            Photographer · Los Angeles, California
          </p>

          <h1 className="max-w-4xl font-serif text-[clamp(4rem,12vw,10rem)] leading-[0.8] tracking-[-0.07em] text-stone-900">
            <span className="block animate-[revealText_900ms_cubic-bezier(0.22,1,0.36,1)_both]">
              Alejandro
            </span>

            <span className="block animate-[revealText_900ms_cubic-bezier(0.22,1,0.36,1)_250ms_both]">
              Armas
            </span>
          </h1>

          <div className="mt-10 h-px w-0 animate-[expandLine_1000ms_cubic-bezier(0.22,1,0.36,1)_600ms_forwards] bg-stone-900" />
        </div>

        <div className="mb-16 grid gap-8 border-b border-stone-300 pb-16 md:grid-cols-[0.7fr_1.3fr]">
          <p className="animate-[fadeUp_700ms_ease-out_700ms_both] text-xs font-medium uppercase tracking-[0.22em] text-stone-500">
            Visual storyteller
          </p>

          <p className="animate-[fadeUp_700ms_ease-out_850ms_both] max-w-2xl text-2xl leading-[1.35] text-stone-700 sm:text-3xl">
            I photograph the spaces between movement and stillness—where light,
            texture, and presence become something worth remembering.
          </p>
        </div>

        <section
          aria-label="About Alejandro Armas"
          className="mb-24 grid gap-5 md:grid-cols-[1.25fr_0.75fr]"
        >
          <figure className="animate-[fadeUp_700ms_ease-out_950ms_both] overflow-hidden bg-stone-200">
            <img
              src={photographerImages.working.src}
              alt={photographerImages.working.alt}
              className="block h-[460px] w-full object-cover object-[50%_05%] transition-transform duration-700 hover:scale-[1.02] md:h-[610px]"
              loading="eager"
            />
          </figure>

          <figure className="animate-[fadeUp_700ms_ease-out_1100ms_both] overflow-hidden bg-stone-200">
            <img
              src={photographerImages.portrait.src}
              alt={photographerImages.portrait.alt}
              className="block h-[460px] w-full object-cover object-[50%_25%] transition-transform duration-700 hover:scale-[1.02] md:h-[610px]"
              loading="lazy"
            />
          </figure>
        </section>

        <div className="grid gap-14 md:grid-cols-[0.7fr_1.3fr]">
          <div className="animate-[fadeUp_700ms_ease-out_1000ms_both]">
            <p className="text-xs font-medium uppercase tracking-[0.22em] text-stone-500">
              Selected notes
            </p>
          </div>

          <div className="space-y-14">
            <article className="group animate-[fadeUp_700ms_ease-out_1100ms_both]">
              <h2 className="mb-4 font-serif text-4xl tracking-tight text-stone-900 transition-transform duration-500 group-hover:translate-x-2">
                Approach
              </h2>

              <p className="max-w-prose text-lg leading-8 text-stone-600">
                Alejandro Armas is a Los Angeles–based photographer working
                across portraiture, lifestyle, and visual storytelling. The
                work begins with close observation: the way natural light
                travels, how a subject inhabits a space, and the details that
                make an image feel human.
              </p>
            </article>

            <article className="group animate-[fadeUp_700ms_ease-out_1250ms_both]">
              <h2 className="mb-4 font-serif text-4xl tracking-tight text-stone-900 transition-transform duration-500 group-hover:translate-x-2">
                Visual language
              </h2>

              <p className="max-w-prose text-lg leading-8 text-stone-600">
                Natural light, cinematic tone, and thoughtful composition shape
                images that are direct but atmospheric. Whether making a
                portrait or documenting a place, the intention is to create
                photographs that feel present now and meaningful later.
              </p>
            </article>

            <article className="group animate-[fadeUp_700ms_ease-out_1400ms_both]">
              <h2 className="mb-4 font-serif text-4xl tracking-tight text-stone-900 transition-transform duration-500 group-hover:translate-x-2">
                Philosophy
              </h2>

              <blockquote className="max-w-prose border-l border-stone-400 pl-6 font-serif text-2xl leading-9 text-stone-700">
                “Photography is not about freezing time. It is about
                translating feeling—between light and subject, memory and
                imagination.”
              </blockquote>
            </article>
          </div>
        </div>
      </section>
    </main>
  );
}

export default About;